import React from 'react';
import { Row, Col } from '../GridSystem';
import { Link } from 'react-router-dom';

const intergerToMonth = (i) => {
    switch (i) {
        case 0:
            return 'JAN';
        
        case 1:
            return 'FEB';
        
        case 2:
            return 'MAR';
        
        case 3:
            return 'APR';
        
        case 4:
            return 'MAY';
        
        case 5:
            return 'JUN';
        
        case 6:
            return 'JUL';
        
        case 7:
            return 'AUG';
        
        case 8:
            return 'SEP';
        
        case 9:
            return 'OCT';
        
        case 10:
            return 'NOV';
        
        case 11:
            return 'DEC';

        default:
            return '';
    }
};

const PostItem = ({data}) => {
    const { 
        date,
        slug,
        title: { rendered: postTitle },
        excerpt: { rendered: postExcerpt }
    } = data;

    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = intergerToMonth(dateObj.getMonth());
    const formattedDate = `${year} ${month}`;

    return (
        <article className="blog-item">
            <div className="blog-item__meta">
                <time dateTime={data.date_gmt} className="blog-item__meta__item">
                    {formattedDate}
                </time>
            </div>
    
            <div className="blog-item__inner">
                <Row>
                    <Col xs={12} md={12} lg={4}>
                        <h2 className="blog-item__title">
                            <Link to={`/blog/${slug}`} title={postTitle}>
                                {postTitle}
                            </Link>
                        </h2>
                    </Col>
    
                    <Col xs={12} md={12} lg={8}>
                        <div className="blog-item__excerpt" dangerouslySetInnerHTML={{__html: postExcerpt}} />
                    </Col>
                </Row>
            </div>
        </article>
    );
};

export default PostItem;


// WEBPACK FOOTER //
// ./src/components/PostItem/index.js